const getToken = () => document.getElementsByName('csrf-token')[0].getAttribute('content');

const buildHeaders = () => ({
  'X-CSRF-Token': getToken(),
  'X-Requested-With': 'XMLHttpRequest',
});

const fetchGeneric = (path, method = 'GET', body = '') =>
  fetch(path, {
    method,
    headers: buildHeaders(),
    credentials: 'same-origin',
    body: method === 'GET' ? undefined : body,
  });

export default fetchGeneric;
